import { Button, Modal } from "semantic-ui-react";

interface DeleteModalProps {
    modalOpen: boolean;
    setModalOpen: (open: boolean) => void;
    handleBuklDelete: (selected: boolean) => void;
    isFiltered?: boolean;
}

export const BulkDeleteModal = ({
    modalOpen,
    setModalOpen,
    handleBuklDelete,
    isFiltered,
}: DeleteModalProps) => {
    const modalText = isFiltered
        ? "Are you sure you want to delete the filtered tables? This will delete all tables that would be returned by the current filter, including tables thatare on different pages in the pagination."
        : "Are you sure you want to delete the selected tables?";

    return (
        <Modal open={modalOpen} onClose={() => setModalOpen(false)}>
            <Modal.Header>Delete {isFiltered ? "filtered" : "selected"} tables</Modal.Header>
            <Modal.Content>
                <p>{modalText}</p>
                <p>
                    Tables will remain visible in published reports, but will NOT be available for
                    new reports including reports created as a hard copy of a previously published
                    report or for published reports that are unpublished.
                </p>
                <p>This action is not reversible!</p>
            </Modal.Content>
            <Modal.Actions>
                <Button content="Cancel" onClick={() => setModalOpen(false)} />
                <Button primary content="Delete" onClick={() => handleBuklDelete(false)} />
            </Modal.Actions>
        </Modal>
    );
};

<p></p>;
